import gql from 'graphql-tag'

export const GET_TOAST = gql`
  query {
    toast @client {
      type,
      message,
      duration,
      shouldDismiss
    }
  }
`

export const SET_TOAST = gql`
  mutation setToast($type: String = null, $message: String!, $duration: Int = null) {
    setToast(toast: {
      type: $type,
      message: $message,
      duration: $duration
    }) @client
  }
`

export const SET_TOAST_DISMISS = gql`
  mutation setToastDismiss {
    setToastDismiss @client
  }
`

export const CLEAR_TOAST = gql`
  mutation clearToast {
    clearToast @client
  }
`
